export const TABS = {
  DETAILS: "Details",
  CUSTOMIZE: "Customize",
  OPTIONS: "Options",
};
